
import React from 'react'

export default props => (
  <span
    className="logoutBtn"
    style={{
      width: '32px',
      height: '32px',
      display: 'block',
      padding: '0px 0 0 3px',
      transform: 'translate(0, -0.1em)',
    }}
  >
    <svg {...props} className="logoutBtnSvg" viewBox="0 0 32 32">
      <path
        className="stroke"
        d="M20 8C20 5.23858 17.7614 3 15 3H8C5.23858 3 3 5.23858 3 8V24C3 26.7614 5.23858 29 8 29H15C17.7614 29 20 26.7614 20 24"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="stroke"
        d="M12 16L29 16M29 16L24.5 12M29 16L24.4231 20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  </span>
)
